import { render } from "./TextComponent.vue?vue&type=template&id=7e5d9828"
const script = {}

import "./TextComponent.vue?vue&type=style&index=0&id=7e5d9828&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__